function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIroningSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 496 496",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#179FC9"
    },
    d: "M391.2,135.6c-10.4-37.6-32-55.2-64.8-55.2H200c-28.8,0-52.8,21.6-56.8,52l0,0c0,3.2-0.8,4.8-0.8,8 c0,13.6,10.4,23.2,24,23.2s24-9.6,24-22.4c0-8.8,4.8-13.6,9.6-13.6h126.4H376c6.4,0,12-0.8,17.6,16.8L391.2,135.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6347D"
    },
    d: "M397.6,240.4H144.8c-76.8,0-130.4,60-133.6,148c0,2.4,0.8,6.4,2.4,8c1.6,2.4,4,4,7.2,4h457.6 c2.4,0,4.8-1.6,7.2-3.2c1.6-1.6,2.4-5.6,2.4-8C484.8,326,490.4,240.4,397.6,240.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1FBED8"
    },
    d: "M482.4,313.2L440,134.8c-10.4-37.6-32-55.2-64.8-55.2h-49.6c32.8,0,54.4,17.6,64.8,55.2l2.4,8 c0,0.8,0.8,1.6,0.8,2.4l41.6,178.4c2.4,11.2,12.8,18.4,23.2,18.4c1.6,0,4,0,5.6-0.8C477.6,338.8,485.6,326,482.4,313.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6347D"
    },
    d: "M483.2,319.6c0-1.6,0-4-0.8-5.6L460,216.4c-1.6,0-3.2,0-4.8,0h-18.4c-9.6,0-18.4,4-24,11.2l-8,14.4 c-2.4,0-4.8-1.6-8-1.6h-252c-76.8,0-130.4,60-133.6,148c0,2.4,0.8,6.4,2.4,8c1.6,2.4,4,4,7.2,4h457.6c2.4,0,4.8-1.6,7.2-3.2 c1.6-1.6,2.4-4.8,2.4-7.2C486.4,367.6,487.2,342,483.2,319.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AD1769"
    },
    d: "M484.8,397.2c1.6-1.6,2.4-4.8,2.4-7.2c-0.8-22.4-0.8-48-4.8-70.4c0-1.6,0-4-0.8-5.6L460,216.4 c-1.6,0-3.2,0-4.8,0h-18.4c-9.6,0-18.4,4-24,11.2l-8,14.4c-2.4,0-4.8-1.6-8-1.6H235.2l156.8,160h85.6 C480.8,400.4,483.2,398.8,484.8,397.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1FBED8"
    },
    d: "M172,87.6c0.8-0.8,1.6-0.8,2.4-1.6C173.6,86.8,172.8,86.8,172,87.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1FBED8"
    },
    d: "M163.2,94c0.8-0.8,1.6-1.6,3.2-2.4C165.6,92.4,164.8,93.2,163.2,94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1FBED8"
    },
    d: "M168,90.8c0.8-0.8,1.6-0.8,2.4-1.6C169.6,89.2,168.8,90,168,90.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1FBED8"
    },
    d: "M162.4,94.8c-0.8,0.8-1.6,1.6-2.4,2.4C160.8,96.4,160.8,95.6,162.4,94.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1FBED8"
    },
    d: "M186.4,82c0.8,0,1.6,0,2.4-0.8C188,82,187.2,82,186.4,82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1FBED8"
    },
    d: "M142.4,130.8c1.6-12.8,10.4-27.2,16.8-33.6C152,105.2,144.8,118,142.4,130.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1FBED8"
    },
    d: "M192,81.2c0.8,0,1.6,0,2.4,0C193.6,80.4,192.8,81.2,192,81.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1FBED8"
    },
    d: "M181.6,83.6c0.8,0,1.6-0.8,2.4-0.8C183.2,82.8,182.4,82.8,181.6,83.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1FBED8"
    },
    d: "M176.8,85.2c0.8-0.8,1.6-0.8,2.4-0.8C178.4,84.4,177.6,84.4,176.8,85.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1FBED8"
    },
    d: "M388.8,132.4L388.8,132.4L388.8,132.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1FBED8"
    },
    d: "M384.8,127.6L384.8,127.6L384.8,127.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1FBED8"
    },
    d: "M386.4,129.2L386.4,129.2L386.4,129.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1FBED8"
    },
    d: "M391.2,137.2L391.2,137.2L391.2,137.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1FBED8"
    },
    d: "M382.4,126L382.4,126L382.4,126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1FBED8"
    },
    d: "M377.6,128.4L377.6,128.4L377.6,128.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1FBED8"
    },
    d: "M380,125.2L380,125.2L380,125.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9EC8CC"
    },
    d: "M342.4,208.4c0,8.8,1.6,16-7.2,16H213.6c-8.8,0-7.2-7.2-7.2-16l0,0c0-8.8,7.2-16,15.2-16h104 C335.2,192.4,342.4,199.6,342.4,208.4L342.4,208.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9EC8CC"
    },
    d: "M496,400.4c0,9.6-7.2,16-16.8,16H16.8c-9.6,0-16.8-6.4-16.8-16l0,0c0-9.6,7.2-16,16.8-16h462.4 C488.8,384.4,496,390.8,496,400.4L496,400.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#85B3B5"
    },
    d: "M496,401.2L496,401.2c0,9.6-7.2,15.2-16.8,15.2H16.8c-9.6,0-16.8-6.4-16.8-16l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#85B3B5"
    },
    d: "M206.4,208.4c0,8.8-1.6,16,7.2,16h121.6c8.8,0,7.2-7.2,7.2-16c0-3.2-1.6-8-3.2-8H209.6 C208,200.4,206.4,206,206.4,208.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#179FC9"
    },
    cx: 226.4,
    cy: 206,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#179FC9"
    },
    cx: 245.6,
    cy: 206,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#179FC9"
    },
    cx: 264.8,
    cy: 206,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#179FC9"
    },
    cx: 284,
    cy: 206,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#179FC9"
    },
    cx: 303.2,
    cy: 206,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#179FC9"
    },
    cx: 322.4,
    cy: 206,
    r: 3.2
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9B1063"
    },
    cx: 179.2,
    cy: 315.6,
    r: 18.4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 179.2,
    cy: 310.8,
    r: 18.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1ECEF"
    },
    d: "M165.6,297.2c7.2-7.2,19.2-7.2,26.4,0s7.2,19.2,0,26.4"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9B1063"
    },
    cx: 248,
    cy: 315.6,
    r: 18.4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 248,
    cy: 310.8,
    r: 18.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1ECEF"
    },
    d: "M234.4,297.2c7.2-7.2,19.2-7.2,26.4,0s7.2,19.2,0,26.4"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9B1063"
    },
    cx: 316.8,
    cy: 315.6,
    r: 18.4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 316.8,
    cy: 310.8,
    r: 18.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1ECEF"
    },
    d: "M303.2,297.2c7.2-7.2,19.2-7.2,26.4,0s7.2,19.2,0,26.4"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIroningSvgrepoCom);
export default __webpack_public_path__ + "static/media/ironing-svgrepo-com.b1f6097f3826df252a50eab87a042695.svg";
export { ForwardRef as ReactComponent };